module.exports = __webpack_public_path__ + "static/media/copa_del_sol_cover.8e5cc326.jpeg";